export const Fraction = ({ value, state, fromtop }) => {
    const [num, den] = value.split('/');

    if (Number(num) === 0) {
        return (
            <div className={`flex items-center justify-center w-[41px] xs:w-[55.87px] sm:w-[40px] ${state ? "xl:w-[96px] lg:w-[72px] md:w-[55.87px]" : "xl:w-[113.87px] lg:w-[93.16px] md:w-[61px]"}`}>
                0
            </div>
        );
    }else if (Number(num) === Number(den)) {
        return (
            <div className={`flex items-center justify-center w-[41px] xs:w-[55.87px] sm:w-[40px] ${state ? "xl:w-[96px] lg:w-[72px] md:w-[55.87px]" : "xl:w-[113.87px] lg:w-[93.16px] md:w-[61px]"}`}>
                1
            </div>
        );
    }

    return (
        <div className={`flex flex-col items-center leading-none w-[41px] xs:w-[55.87px] sm:w-[40px] ${state ? "xl:w-[96px] lg:w-[72px] md:w-[55.87px]" : "xl:w-[113.87px] lg:w-[93.16px] md:w-[61px]"}`}>
            <div>{num}</div>
            <div className={`w-full border-t-[2px] ${fromtop ? "border-purple-700" : ''} my-[2px]`} />
            <div>{den}</div>
        </div>
    );
};